import React, { useEffect, useState, Children } from 'react';
import { EditRoomForm } from '../components/EditRoomForm';
export function EditRoom() {
  const [roomData, setRoomData] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    // In a real application, this would fetch room data from an API
    // For now, we'll just simulate loading data
    const searchParams = new URLSearchParams(window.location.search);
    const roomId = searchParams.get('id');
    // Mock data
    const mockRoomData = {
      id: roomId || '1',
      name: 'Premium Overwater Villa',
      category: 'OVERWATER_VILLA',
      code: 'POWVDTAC',
      description: 'Perched above the crystal-clear lagoon, the Premium Overwater Villa offers uninterrupted views of the Indian Ocean and direct access to the water from a private sun deck. Designed for ultimate relaxation and comfort.',
      isSmoking: false,
      isAccessible: false,
      isActive: true,
      view: 'SEA_VIEW',
      size: '250',
      amenities: ['Wi-Fi', 'TV', 'Minibar', 'Air Conditioning', 'Balcony', 'Terrace', 'Ocean View', 'Private Pool', 'Jacuzzi', 'Slippers', 'Desk', 'Dining Area', 'Interconnecting Rooms', 'Non-Smoking', 'Beach Access', 'Breakfast Included'],
      baseAdultsOccupancy: 4,
      baseChildrenOccupancy: 2,
      maxOccupancy: 6,
      allowAdditionalAdults: false,
      allowAdditionalChildren: false,
      bedConfigurations: [{
        type: 'King',
        count: 1
      }, {
        type: 'Queen',
        count: 1
      }]
    };
    setTimeout(() => {
      setRoomData(mockRoomData);
      setLoading(false);
    }, 500);
  }, []);
  const handleSaveRoom = (updatedRoomData: any) => {
    // In a real application, this would save the updated room data to an API
    console.log('Saving updated room data:', updatedRoomData);
    // Navigate back to rooms list
    window.location.href = '/rooms';
  };
  const handleCancel = () => {
    window.location.href = '/rooms';
  };
  const handleNavigateToAssets = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const roomId = searchParams.get('id');
    window.location.href = `/room-detail?id=${roomId}`;
  };
  if (loading) {
    return <div className="flex justify-center items-center h-64" data-id="element-10265">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-red-600" data-id="element-10266"></div>
      </div>;
  }
  return <div data-id="element-10267">
      <EditRoomForm roomData={roomData} onSave={handleSaveRoom} onCancel={handleCancel} onNavigateToAssets={handleNavigateToAssets} data-id="element-10268" />
      
    </div>;
}